export const getCookieConfig = (langFile) => [
    {
        id: 'essential',
        title: langFile.system,
        description: langFile.systemDesc,
        disabled: true,
        services: []
    },
    {
        id: 'analytics',
        title: langFile.analytics,
        description: langFile.analyticsDesc,
        legacyTag: 'analytics_storage',
        services: [
            {
                id: 'gtm2',
                label: { fr: 'Google Tag Manager (Mesure d\'utilisation)', en: 'Google Tag Manager (Usage Metric)' },
                consentKey: 'analytics_storage'
            }
        ]
    },
    {
        id: 'media',
        title: langFile.media,
        description: langFile.mediaDesc,
        legacyTag: 'media_storage',
        services: [
            {
                id: 'youtube',
                label: { fr: 'Lecteur de vidéo YouTube', en: 'YouTube Video Player' },
                consentKey: 'media_storage'
            },
            {
                id: 'vimeo',
                label: { fr: 'Lecteur de vidéo Vimeo', en: 'Vimeo Video Player' },
                consentKey: 'media_storage'
            },
            {
                id: 'giphy',
                label: { fr: 'Plateforme de GIF Giphy', en: 'Giphy GIF Platform' },
                consentKey: 'media_storage'
            },
            {
                id: 'formgoogle',
                label: { fr: 'Formulaires Google', en: 'Google Forms Integration' },
                consentKey: 'media_storage'
            },
            {
                id: 'googlemap',
                label: { fr: 'Cartes Google Maps', en: 'Google Maps Interactive Layer' },
                consentKey: 'media_storage'
            },
            {
                id: 'soundcloud',
                label: { fr: 'Lecteur audio SoundCloud', en: 'SoundCloud Audio Player' },
                consentKey: 'media_storage'
            },
            {
                id: 'sketchfab',
                label: { fr: 'Plateforme de ressources 3D SketchFab', en: 'SketchFab 3D Assets Platform' },
                consentKey: 'media_storage'
            }
        ],
    }
]